import axios from 'axios';

export default class HttpInterceptor {


	_request = null;

	constructor(baseUrl) {
		this._request = axios.create({
			baseURL: baseUrl,
			crossDomain: true,
		});
		this._configInterceptRequest();
		this._configInterceptResponse();
	}


	_configInterceptResponse = () => {
		this._request.interceptors.response.use(this._handleSuccess, this._handleError);
	};

	_configInterceptRequest = () => {
		this._request.interceptors.request.use(this._requestCallBack);
	};

	_requestCallBack = (config) => {
		config.headers = {
			accept: 'application/json',
			'x-access-token': window.localStorage.getItem('token'),
		};
		return config;
	};

	_handleSuccess = (res) => {
		return res;
	};

	_handleError = (error) => {
		switch (error.response.status) {
			case 401:
				window.localStorage.removeItem('token');
				this.redirectTo(document, '/account/login');
				break;
			default:
				break;
		}
		return Promise.reject(error);
	};


	redirectTo = (document, path) => {
		document.location = path;
	};

	getRequest = () => this._request;
}



